import classNames from 'classnames';
import { InStock } from '@/core/tamagoshi/InStock/InStock';
import { merchandisingLabels } from '@/core/tamagoshi/MerchandisingTag/interfaces';
import { Tag, TagColor } from '@/core/tamagoshi/Tag/Tag';
import { SponsoredLabel } from '@/core/tamagoshiTailwind/components/Label/SponsoredLabel';
import { TrendDownIcon } from '@/core/tamagoshiTailwind/icons/TrendDownIcon';
import { ProductCardTag, productLabels, type ProductCardListingsTranslations } from '../../interfaces';
import styles from './ProductTags.module.scss';
export const ProductTagsColor: Record<ProductCardTag, TagColor> = {
  proPriceAdvantage: 'orange',
  bulk: 'beige',
  coupon: 'beige',
  sponsored: 'beige',
  topSale: 'lightBlue',
  promo: 'red',
  bestQualityOffer: 'lightBlue',
  inStock: 'beige',
  ecoResponsible: 'lightGrey',
  blackFriday: 'black',
  sales: 'red',
  manomanoDays: 'red',
  madeIn: 'lightGrey',
  secondHand: 'lightGreen',
  technicalInfo: 'lightGrey',
  loweredprice: 'red'
};
export interface ProductTagsProps {
  className?: string;
  promoted?: boolean;
  secondHand?: boolean;
  tags: ProductCardTag[];
  translations: ProductCardListingsTranslations['tags'];
  onAdvertiserLabelClicked?(event: React.MouseEvent<HTMLElement, MouseEvent>): unknown;
}
export const ProductTags = ({
  tags,
  translations,
  className,
  promoted,
  onAdvertiserLabelClicked
}: ProductTagsProps) => {
  const InnerTags = tags.map((tag, i) => {
    const translatedLabel = translations[tag as keyof typeof translations]?.label;
    if (tag === productLabels.SPONSORED && onAdvertiserLabelClicked) {
      return <div className={className} key={tag}>
          <SponsoredLabel label={translations.sponsored.label} onClick={onAdvertiserLabelClicked} />
        </div>;
    }
    if (translatedLabel) {
      return <Tag className={classNames(className, styles.tag, {
        [styles.loweredPrice]: tag === merchandisingLabels.LOWERED_PRICE
      })} color={ProductTagsColor[tag]} key={`${tag}-${i}`} revamp as="span">
          {translatedLabel}
          {tag === merchandisingLabels.LOWERED_PRICE && <TrendDownIcon />}
        </Tag>;
    }
    if (tag) {
      return <Tag className={classNames(className, styles.tag)} color={ProductTagsColor.technicalInfo} key={`${tag}-${i}`} revamp as="span">
          {tag}
        </Tag>;
    }
  });
  if (promoted) InnerTags.push(<InStock className={styles.inStock} key="in-stock-label" label={translations.inStock.label} />);
  return <>
      {InnerTags.length > 1 ? <div className={classNames(className, styles.tagContainer)}>
          {InnerTags}
        </div> : InnerTags}
    </>;
};
ProductTags.displayName = 'ProductTags';